var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62,
    height: 42,
    viewBox: "0 0 62 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_145989",
    x: 0,
    y: 0,
    width: 62,
    height: 42,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_104698",
    "data-name": "Group 104698",
    transform: "translate(-12767 -1005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104549",
    "data-name": "Group 104549"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104511",
    "data-name": "Group 104511",
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_78914",
    "data-name": "Group 78914",
    transform: "translate(12776.513 1008)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8.51, -3)",
    filter: "url(#Rectangle_145989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_145989-2",
    "data-name": "Rectangle 145989",
    transform: "translate(9 6)",
    fill: "rgba(255,255,255,0)",
    stroke: "#828282",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 24,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 42.5,
    height: 22.5,
    rx: 2.25,
    fill: "none"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_64233",
    "data-name": "Path 64233",
    d: "M-6528.138,4718.9v-9.036h8.35",
    transform: "translate(19301 -3701.904)",
    fill: "none",
    stroke: "#828282",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64236",
    "data-name": "Path 64236",
    d: "M-6519.788,4718.9v-9.036h-8.35",
    transform: "translate(19343 -3701.904)",
    fill: "none",
    stroke: "#828282",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64234",
    "data-name": "Path 64234",
    d: "M-6528.138,4709.868v9.036h8.35",
    transform: "translate(19301 -3680.904)",
    fill: "none",
    stroke: "#828282",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64235",
    "data-name": "Path 64235",
    d: "M-6519.788,4709.868v9.036h-8.35",
    transform: "translate(19343 -3680.904)",
    fill: "none",
    stroke: "#828282",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFill);
export default __webpack_public_path__ + "static/media/Fill.47afe59ee3918e1019719a4b276ad837.svg";
export { ForwardRef as ReactComponent };